import { useMediaQuery } from 'react-responsive'
import React from "react"
import styled from 'styled-components'
import Img from "gatsby-image"

const Story = styled.div`
width: 95%;
border-radius: 10px;
    background: white;
    max-height: 100%;
    position: relative;
    overflow-y: auto;

    > img {
      height: 340px;
      width: 100%;
      object-fit: cover;
      margin-bottom: 0;
    };
    
    > .story-info {
      padding: 30px;
    }

    ::-webkit-scrollbar {
      display: none;
    };
  `

export const StoryTemplate = ({
    title,
    date,
    bannerImage,
    html,
    width
  }, ) => {
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1025px)' });

  return (
    <Story style={{width: `${width}%`}}>
      <div className="story-info">
        { isTabletOrMobile ? <h2>{title}</h2> : <h1>{title}</h1> }
        <h6>{date.toUpperCase()}</h6>
      </div>
      {typeof bannerImage === 'object' ? <Img fluid={bannerImage} /> : '' }
      <div className="story-info" dangerouslySetInnerHTML={{ __html: html }} />
    </Story>
  )
}

// We export this element which takes in the props, parses them into simple props for the template and returns the template
const StoryExport = (props) => {
  const { markdownRemark } = props.data // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark
  const bannerImage = frontmatter.image.childImageSharp.fluid

  return (
    <StoryTemplate
      title={frontmatter.title}
      date={frontmatter.date}
      bannerImage={bannerImage}
      html={html}
      width={props.width}
    />
  )
}

export default StoryExport